import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { User, Mail, Shield, Building2 } from 'lucide-react';

export default function Profile() {
  const { user } = useAuth();

  const roleLabels = {
    super_admin: 'Super Administrateur',
    company_admin: 'Administrateur Entreprise',
    hr: 'Ressources Humaines',
    director: 'Directeur'
  };

  return (
    <div className="space-y-6" data-testid="profile-page">
      <div>
        <h1 className="font-heading font-bold text-3xl text-slate-900">Mon Profil</h1>
        <p className="text-slate-600 mt-1">Informations de votre compte</p>
      </div>

      <Card className="border-slate-200 max-w-2xl">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <User className="w-5 h-5 text-primary" />
            Informations Personnelles
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-center gap-4">
            <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center">
              <span className="text-white text-2xl font-bold">
                {user?.full_name?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <h2 className="font-heading font-bold text-2xl text-slate-900">{user?.full_name}</h2>
              <Badge className="mt-2 bg-primary">{roleLabels[user?.role] || user?.role}</Badge>
            </div>
          </div>

          <div className="space-y-4 pt-4 border-t border-slate-200">
            <div className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-slate-400" />
              <div>
                <p className="text-sm text-slate-500">Email</p>
                <p className="font-medium text-slate-900">{user?.email}</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <Shield className="w-5 h-5 text-slate-400" />
              <div>
                <p className="text-sm text-slate-500">Rôle</p>
                <p className="font-medium text-slate-900">{roleLabels[user?.role] || user?.role}</p>
              </div>
            </div>

            {user?.company_id && (
              <div className="flex items-center gap-3">
                <Building2 className="w-5 h-5 text-slate-400" />
                <div>
                  <p className="text-sm text-slate-500">Entreprise</p>
                  <p className="font-medium text-slate-900">ID: {user.company_id}</p>
                </div>
              </div>
            )}

            <div className="flex items-center gap-3">
              <User className="w-5 h-5 text-slate-400" />
              <div>
                <p className="text-sm text-slate-500">Statut</p>
                <Badge variant={user?.is_active ? 'success' : 'destructive'} className={user?.is_active ? 'bg-success text-white' : 'bg-error text-white'}>
                  {user?.is_active ? 'Actif' : 'Inactif'}
                </Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
